/**
 * @author Ashish Dwivedi <ashish.dwivedi@314ecorp.com>
 * @description utils for Payments
 */
import { ANALYTICS_USER_ROLE, BILLING_ADMIN_ROLE, BILLING_USER_ROLE, INTERNAL_ADMIN_ROLE, SUPER_ADMIN_ROLE } from 'configs/index';
import _ from 'lodash';

const formatNumber = (num: number): string => {
	const billion = 1000000000;
	const million = 1000000;
	if (num > billion) {
		return `${_.round(num / billion, 2).toLocaleString()} B`;
	}
	if (num > million) {
		return `${_.round(num / million, 2).toLocaleString()} M`;
	}
	return num > 0 ? num?.toLocaleString() : _.toString(num);
};

const formatCurrency = (num: number = 0): string => {
	return num || num === 0 ? `$${formatNumber(num)}` : '';
};

const IMAGE_FORMAT_MAPPING = {
	iVBORw0KGgo: 'data:image/png;base64,',
	'/9j/': 'data:image/jpeg;base64,',
	UklGRg: 'data:image/webp;base64,',
	PD94bWwgdmVyc2lvbj0iMS4w: 'data:image/svg+xml;base64,',
};

const getBase64Url = (url: string): string => {
	if (_.isEmpty(url)) {
		return '';
	}
	const imageUrlPrefix = _.find(IMAGE_FORMAT_MAPPING, (__, format) => _.startsWith(url, format));
	return imageUrlPrefix ? `${imageUrlPrefix}${url}` : url;
};

const getRoleBasedFieldDisabled = (userAccess: App.UserAccess, data?: GeneralSettings.IAccessSchema): Record<string, boolean> => {
	const rolesList: UserManagement.IRoleName[] = [ANALYTICS_USER_ROLE];

	if (userAccess.isBillingUser) {
		rolesList.push(BILLING_USER_ROLE);
	}

	if (userAccess.isBillingAdmin) {
		rolesList.push(BILLING_ADMIN_ROLE);
	}

	if (userAccess.isSuperAdmin) {
		rolesList.push(SUPER_ADMIN_ROLE);
	}

	if (userAccess.isInternalAdmin) {
		rolesList.push(INTERNAL_ADMIN_ROLE);
	}

	return _.mapValues(data, (item?: GeneralSettings.IAccessSchemaItem) => {
		if (item && _.isObject(item) && _.isArray(item?.ac_roles)) {
			return _.isEmpty(_.intersection(item?.ac_roles, rolesList));
		}
		return false;
	});
};

export { formatCurrency, getBase64Url, getRoleBasedFieldDisabled };
